import React from "react";
import MainFeatures from "./mainFeature";

const carfeature = (props) => {
  return (
    <section className="car-feature">
      <div className="car-feature-wrap">
        <div className="feature-title">{props.cartitle}</div>

        <div className="feature-icons">
            <MainFeatures />
        </div>

        <div className="detail">
          <p>Extra km charge @ ₹ 13/km</p>
        </div>
      </div>
    </section>
  );
};

export default carfeature;
